// eslint-disable-next-line import/prefer-default-export -- this will expand in future
export const findByLabel = (data, label) =>
  data.find((item) => item.label === label);
